
import { Component, Vue } from 'vue-property-decorator'
import { AppEditableHeader, AppSwitchForm } from '@/components'
import DetailBasicForm from '@/components/DetailBasicForm.vue'
import RequestUpdateValidation from '@/components/RequestUpdateValidation.vue'
import { appAccountEntity, appEntity, appInfoEntity } from '@/models/models'
import { cloneDeep } from 'lodash'
import { ChildComponentMixin } from '@/mixins'
import DetailAppleDeveloperProgramForm from '@/components/DetailAppleDeveloperProgramForm.vue'
import DetailAppleAccountForm from '@/components/DetailAppleAccountForm.vue'
import DetailDDAppleAccountForm from '@/components/DetailDDAppleAccountForm.vue'
import DetailAndroidAccountForm from '@/components/DetailAndroidAccountForm.vue'
import VueScrollTo from 'vue-scrollto'
import '@/extensions/string'
import { iOSLoginIsRequired, iOSLoginUrl } from '@/utils/fastlane'

Vue.use(VueScrollTo)

@Component({
    components: {
        AppEditableHeader,
        AppSwitchForm,
        DetailAndroidAccountForm,
        DetailAppleAccountForm,
        DetailDDAppleAccountForm,
        DetailAppleDeveloperProgramForm,
        DetailBasicForm,
        RequestUpdateValidation,
    },
})
export default class RequestUpdate extends ChildComponentMixin {
    private app: AppEntity = cloneDeep(appEntity)

    get isLoading(): boolean {
        return this.$store.state.detail.isLoading
    }

    get hasDevPermissions(): boolean {
        return this.app.android!.updates.length > 0
            && (this.app.account?.androidType?.length ?? 0) > 0
            && (this.app.account?.apiKey?.length ?? 0) > 0
    }

    public async mounted() {
        if (this.$route.params.id == null) {
            return
        }

        const requestedApp = await this.$store.dispatch(
            'detail/getApp',
            this.$route.params.id,
        )

        this.app = { ...this.app, ...requestedApp }
        this.app.android = { ...appInfoEntity, ...requestedApp.android }
        this.app.iOS = { ...appInfoEntity, ...requestedApp.iOS }
        this.app.brand = { ...appInfoEntity, ...requestedApp.brand }
        this.app.account = { ...appAccountEntity, ...requestedApp.account }

        this.app.account!.hasDevPermissions = this.hasDevPermissions

        if (this.$route.params.platform === 'ios') {
            this.app.iOS!.request = true
        } else if (this.$route.params.platform === 'android') {
            this.app.android!.request = true
        }

        this.app.validateOnlyRequested = true
    }

    public onClose() {
        this.$router.back()
    }

    public async onSave() {
        const response = await this.$store.dispatch(
            'detail/requestUpdate',
            this.app,
        )

        if (response == null) {
            alert(
                'Erro ao requisitar update de app. Por favor, tente novamente ou entre em contato com um de nossos desenvolvedores',
            )
            return
        }

        const errors = response.errors
        if (errors != null && Object.keys(errors).length > 0) {
            this.app = response
            setTimeout(() => {
                this.$scrollTo('#error', 500, { offset: -100 })
            }, 100)
            return
        }

        if (iOSLoginIsRequired(this.app)) {
            window.open(iOSLoginUrl(this.app), '_blank')
        }

        this.$router.back()
    }
}
